import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Modal from "../../components/modal";
import Author from "components/author";
import { useStoreActions, useStoreState } from "easy-peasy";
import moment from "moment";

export default function TransfersPopup() {
  const transfers = useStoreState((state) => state.transfers);
  const setTransfers = useStoreActions((actions) => actions.setTransfers);

  const onClose = () => {
    setTransfers(null);
  };

  if (!transfers) {
    return null;
  }
  return (
    <Modal
      open={transfers.length > 0}
      title={"Transfer History"}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton onClick={onClose} variant="gradient" color="error">
            close
          </MDButton>
        </MDBox>
      }
    >
      {transfers.map((account) => (
        <div key={account.id}>
          <Author name={account.holder_name} address={account.address} />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "15px",
              marginBottom: "20px",
              alignItems: "center",
            }}
          >
            <div style={{ height: 1, background: "#d3d3d3", width: "100%" }} />
            {account.transferred_date ? (
              <div style={{ width: "200px", textAlign: "center", fontSize: "12px" }}>
                {moment(account.transferred_date).format("YYYY-MM-DD")}
              </div>
            ) : (
              <div />
            )}
            <div style={{ height: 1, background: "#d3d3d3", width: "100%" }} />
          </div>
        </div>
      ))}
    </Modal>
  );
}
